/**
 * @generated SignedSource<<ec9413ac945cf7e8edcfc8aef613c614>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user">;
  readonly " $fragmentType": "PdpRespSidebarContact_user";
};
export type PdpRespSidebarContact_user$key = {
  readonly " $data"?: PdpRespSidebarContact_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarContact_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6d8d2c9b5051683a29be668aabdbfcc4";

export default node;
